import {Contract} from "./contract";

export class Service {
  id: string;
  service: string;
  description: string;
  type: string;
  contract: Contract;
  contractId: string;
}



// WEBPACK FOOTER //
// ./src/classes/service.ts